// Department-based field permissions are UI-only (no backend enforcement -
// this app has no login-based auth anywhere, by design). Missing/undefined
// for a given key means "allowed" - a department only needs an entry here
// once you actually want to hide something from it.
//
// Only fields that are genuinely optional extras are listed - never a field
// a form structurally requires to submit at all (e.g. project, crew, issue
// description, expected completion date), since hiding those would just
// break submission for that department.

export const DAILY_ENTRY_FIELDS = [
  { key: 'hours_logged', label: 'Hours Logged' },
  { key: 'work_description', label: 'Work Description' },
  { key: 'activity', label: 'Category / Activity / Checkpoint' },
  { key: 'is_rework', label: 'Rework Flag' },
];

export const PUNCH_POINT_FIELDS = [
  { key: 'punch_point_type', label: 'Issue Type' },
  { key: 'category', label: 'Category (free text)' },
  { key: 'severity', label: 'Severity' },
  { key: 'assignment', label: 'Assignment (Supervisor / Department)' },
];

// True unless explicitly set to false.
export const isFieldAllowed = (fieldPermissions, form, key) => {
  const value = fieldPermissions?.[form]?.[key];
  return value !== false;
};
